export enum EEventTypes {
  GTM_UI_EVENT = 'gtm-ui-event',
}

export enum GTMEventName {
  generalRegistration = 'general_registration',
  eventRegistration = 'event_registration',
  partnerRegistration = 'partner_registration',
  createCompanyStep = 'create_company_step',
  partnerOnboardingFirstStep = 'partner_onboarding_first_step',
  partnerOnboardingSecondStep = 'partner_onboarding_add_billing_info',
  partnerOnboardingThirdStep = 'partner_onboarding_enter_card_data',
  eventOnboardingFirstStep = 'event_onboarding_fill_company_details',
  eventOnboardingSecondStep = 'event_onboarding_add_first_event',
  login = 'login',
  menuItemClick = 'menu_item_click',
  eventCatalog = 'event_catalog',
  profile = 'profile',
  partnerEventAction = 'partner_event_action',
  partnerEventCatalogAction = 'partner_event_catalog_action',
  saveLanding = 'save_landing',
  deleteCampaign = 'delete_campaign',
  pageVisit = 'page_visit',
  saveCampaign = 'save_campaign',
  confirmEmail = 'confirm_email',
  changeProfile = 'change_profile',
  viewNotifications = 'view_notifications',
  cancelProSubscription = 'cancel_pro_subscription',
  enableProSubscription = 'enable_pro_subscription',
  enterCardData = 'enter_card_data',
  saveEvent = 'save_event',
  publishEvent = 'publish_event',
  addInvitations = 'add_invitations',
  inviteStatus = 'invite_status',
  landingStatus = 'landing_status',
  addBillingInfo = 'add_billing_info',
  click_try_free = 'click_try_free',
  video_click = 'video_click',
  video_play = 'video_play',
  video_play_25 = 'video_play_25',
  video_play_50 = 'video_play_50',
  video_play_75 = 'video_play_75',
  video_play_95 = 'video_play_95',
  click_terms = 'click_terms',
  click_cookie_policy = 'click_cookie_policy',
  click_privacy_policy = 'click_privacy_policy',
  click_pricing_annual_switch_on = 'click_pricing_annual_switch_on',
  click_pricing_go_basic_monthly = 'click_pricing_go_basic_monthly',
  click_pricing_go_basic_yearly = 'click_pricing_go_basic_yearly',
  click_pricing_go_pro_monthly = 'click_pricing_go_pro_monthly',
  click_pricing_go_pro_yearly = 'click_pricing_go_pro_yearly',
  click_pricing_enterprise_sales_monthly = 'click_pricing_enterprise_sales_monthly',
  click_pricing_enterprise_sales_yearly = 'click_pricing_enterprise_sales_yearly',
  create_account_page_loaded = 'create_account_page_loaded',
  create_account_email_focus = 'create_account_email_focus',
  create_account_email_error = 'create_account_email_error',
  create_account_password_focus = 'create_account_password_focus',
  create_account_password_error = 'create_account_password_error',
  create_account_password_check_showed = 'create_account_password_check_showed',
  create_account_click_forget_password = 'create_account_click_forget_password',
  create_account_terms_checked = 'create_account_terms_checked',
  create_account_click_signup = 'create_account_click_signup',
  create_account_click_google = 'create_account_click_google',
  create_account_click_login = 'create_account_click_login',
  registration_name_focus = 'registration_name_focus',
  registration_company_focus = 'registration_company_focus',
  registration_website_focus = 'registration_website_focus',
  registration_website_error = 'registration_website_error',
  registration_phone_focus = 'registration_phone_focus',
  registration_phone_error = 'registration_phone_error',
  registration_click_continue = 'registration_click_continue',
}

export enum GTMPlaces {
  header = 'header',
  hero_screen = 'hero_screen',
  pricing = 'pricing',
  bottom_cta = 'bottom_cta',
  view_demo_button = 'view_demo_button',
  footer = 'footer',
  create_account = 'create_account',
}

export enum GTMResources {
  landing_page = 'landing_page',
  app_invite_page = 'app_invite_page',
  app_billing = 'app_billing',
}

export enum GTMErrorStatuses {
  error = 'error',
  ok = 'ok',
}

export enum GTMLPVersions {
  A = 'A',
  B = 'B',
  C = 'C',
}
